import Api from "@/repository/ApiBase";
import {CreateTopic, GetTopicResponse, UpdateTopic} from "@/repository/messagehub.dtos";
import {AxiosResponse} from "axios";

export class TopicApi extends Api {

    async getTopics(): Promise<GetTopicResponse>{
        let result: AxiosResponse =  await this.Client.get('/topic')
        return <GetTopicResponse> result.data
    }
    async getTopicsInChannel(channelId: string): Promise<GetTopicResponse>{
        let result: AxiosResponse =  await this.Client.get('/topic/channel?id='+channelId)
        return <GetTopicResponse> result.data
    }
    async createTopic(topic: CreateTopic): Promise<AxiosResponse>{
        const json = JSON.stringify(topic);
        let result: AxiosResponse = await this.Client.post('/topic', json)
        return result
    }
    async updateTopic(topic: UpdateTopic){
        const json = JSON.stringify(topic);
        let result: AxiosResponse = await this.Client.put('/topic', json)
        return result
    }
    async deleteTopic(id: string){
        let result: AxiosResponse = await this.Client.delete('/topic?id='+id)
        return result
    }
}
